export const ANDROID_BANNER_HEIGHT = 52;
